module.exports = __webpack_public_path__ + "static/winterova-dc163b8323f8e2f60bb53787fcad0f62.jpg";